import {AxiosInstance} from "axios";
import API from "../../utils/api";

export class AgentTypesService {
    api: AxiosInstance = API;

    async getTypes(): Promise<string[]> {
        return this.api.get("agents/legal-types").then(x => x.data);
    }
}

export const agentTypesService = new AgentTypesService();
